import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

type SiteContentMap = Record<string, Record<string, any>>;

export function useSiteContent() {
  return useQuery({
    queryKey: ["site-content-all"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_content")
        .select("section_key, content");
      if (error) throw error;
      const map: SiteContentMap = {};
      data?.forEach((row) => {
        map[row.section_key] = row.content as Record<string, any>;
      });
      return map;
    },
    staleTime: 5 * 60 * 1000, // 5 min cache
  });
}

export function useSiteSection(key: string) {
  const { data, isLoading } = useSiteContent();
  return { data: data?.[key] || null, isLoading };
}
